import styled from 'styled-components'
import { Column, Row } from '@sainsburys-tech/bolt'
import { RichText } from '../../../helpers/StyledWrappers.styles'

const padding = (props) => props.theme.size.spacing.lg

export const ColumnWrapper = styled(Column)`
  ${RichText}
`

export const RowWrapper = styled(Row)`
  padding: 0 ${padding} ${padding} 0;
`

export const GridContainer = styled(Row)`
  padding-bottom: ${padding};
`
